import { useEffect, useState } from "react";
import useUserRoles from "./useUserRoles";

const useIsAdminAndViewOnly = () => {
  const roles = useUserRoles();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);

  useEffect(() => {
    const hasAdmin = roles.includes("Admin");
    const hasViewOnly = roles.includes("ViewOnly");

    if (hasAdmin) {
      setIsAdmin(true);
      setIsViewOnly(false); // Force ViewOnly to false if Admin
    } else if (hasViewOnly) {
      setIsAdmin(false); // Force Admin to false if ViewOnly
      setIsViewOnly(true);
    } else {
      // Neither role is present
      setIsAdmin(false);
      setIsViewOnly(false);
    }
  }, [roles]);

  return { isAdmin, isViewOnly };
};

export default useIsAdminAndViewOnly;
